module.exports = __webpack_public_path__ + "static/img/img_title_12.63a83b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_12.png
// module id = 553
// module chunks = 1